<!-- 摄像头弹窗DEMO -->
<template>
  <div v-draggable v-if="visible" class="shipInfoDialog">
    <div class="shipInfoDialog-header">
      <div class="shipInfoDialog-header-info">
        <div class="shipInfoDialog-header-info-item">
          <img v-if="data?.shipNationality == '中国'" src="@/assets/china.png" alt="" />
          <span>{{ data?.name }}</span>
        </div>
        <p>
          <!-- <span
            >更新：{{ data?.from ? dayjs(data?.mt).format('YYYY/MM/DD HH:mm:ss') : '-' }}</span
          > -->
          <span>数据来源：{{ data?.dataType }}</span>
        </p>
      </div>
      <el-icon @click="visible = false" size="18" color="#909399">
        <Close />
      </el-icon>
    </div>

    <div class="shipInfoDialog-content">
      <div class="shipInfoDialog-content-item">
        <div v-for="(item, i) in viewsList" :key="i" class="shipInfoDialog-content-item-box">
          <span class="shipInfoDialog-content-item-box-name">{{ item.name }}</span>
          <span class="shipInfoDialog-content-item-box-value">{{ item.value ?? ' - ' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { computed, onMounted, ref } from 'vue'
import { type IshipAllInfo } from '@/apiFzn/types'
import { Close } from '@element-plus/icons-vue'
import draggable from './draggable'
import { omitBy } from 'lodash-es'
// 局部注册指令
const vDraggable = draggable
const visible = ref(false)
const data = ref<IshipAllInfo>()

onMounted(async () => {
  const cesiumobj = await CesiumObj.getInstance()
  cesiumobj.layerManager.ship66Layer.on('click', (p) => {
    data.value = p
    visible.value = true
  })
})

const viewsList = computed(() => {
  const val = omitBy((data.value ?? {}) as IshipAllInfo, (val) => {
    return typeof val == 'string' && val.length == 0
  })
  return [
    {
      name: 'MMSI',
      value: val?.mmsi,
    },
    {
      name: '状态',
      value: val?.status ?? '-',
    },
    {
      name: '航速',
      value: val?.speed ?? '-',
    },

    {
      name: '定位类型',
      value: val?.locatePrecision ?? '-',
    },
    {
      name: '航向',
      value: val?.course ?? '-',
    },
    {
      name: '定位精度',
      value: val?.locatePrecision ?? '-',
    },
    {
      name: '艏向',
      value: val?.heading ?? '-',
    },
    {
      name: '目的地',
      value: val?.dest ?? '-',
    },
    {
      name: '纬度',
      value: val?.latitude ?? '-',
    },

    {
      name: '预到时间',
      value: val?.arrivalTimeStr ?? '-',
    },
    {
      name: '经度',
      value: val?.longitude ?? '-',
    },
    {
      name: '建造年份',
      value: val?.shipYear ?? '-',
    },
    {
      name: '呼号',
      value: val?.callSign ?? '-',
    },
    {
      name: '长度',
      value: val?.len ?? '-',
    },
    {
      name: 'IMO',
      value: val?.imo ?? '-',
    },
    {
      name: '宽度',
      value: val?.wid ?? '-',
    },
    {
      name: '船籍',
      value: val?.shipNationality ?? '-',
    },
    {
      name: '吃水',
      value: val?.eatWater ?? '-',
    },
    {
      name: '船型',
      value: val?.type ?? '-',
    },
    {
      name: '总吨',
      value: val?.gt ?? '-',
    },
  ]
})
</script>

<style lang="scss" scoped>
.shipInfoDialog {
  position: fixed;
  right: 20px;
  top: 170px;
  width: 380px;
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  z-index: 999;
  border-radius: 8px;
  box-shadow:
    0px 12px 32px 4px rgba(0, 0, 0, 0.04),
    0px 8px 20px rgba(0, 0, 0, 0.08);

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 8px;
    &-info {
      color: #646362;
      width: 100%;
      &-item {
        width: 100%;
        display: flex;
        align-items: center;
        > img {
          width: 60px;
        }
        > span {
          font-size: 16px;
          color: #666;
          display: inline-block;
          padding-left: 5px;
        }
      }

      > p {
        font-size: 16px;
        color: #999;
        margin-top: 2px;
        span {
          margin-right: 8px;
        }
      }
    }

    .el-icon {
      cursor: pointer;
      &:hover {
        color: #3b82f6;
      }
    }
  }

  &-content {
    &-item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &-box {
        width: 50%;
        display: flex;
        font-size: 12px;
        margin-bottom: 6px;
        &-name {
          width: 60px;
          text-align: justify;
          text-align-last: justify;
          text-justify: distribute-all-lines;
          color: #7c8196;
          &::after {
            content: '：';
          }
        }

        &-value {
          margin-left: 6px;
        }
      }
    }
  }
}
</style>
